{
  "es": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Cambiar hito",
        "reset_columns": "Restablecer columnas"
      },
      "labels": {
        "columns": "Columnas",
        "milestone": "Selecciona un nuevo hito",
        "no_results": "No se han encontrado unidades"
      }
    }
  }
}
